<template>
  <v-flex data-qa="addnewpayee-flex-dkfwqn">
    <Loader v-if="loaderEnabled" />
    <v-layout class="payee--gradientBGposition" data-qa="addnewpayee-layout-j792rb">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '180px' }"
        data-qa="addnewpayee-flex-19jq"
      >
        <v-container class="payee--title-padding" data-qa="addnewpayee-container-9joko">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="addnewpayee-flex-xmg1ec">
            <v-row no-gutters data-qa="addnewpayee-row-tekfx65">
              <v-layout row wrap class="pb-2" data-qa="addnewpayee-layout-aiyw76">
                <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="addnewpayee-flex-5whtge">
                  <v-row justify="end" data-qa="addnewpayee-row-zreuk">
                    <v-avatar :tile="false" size="35" color="white" data-qa="addnewpayee-avatar-q9iqjd">
                      <inline-svg
                        v-if="enableSortCodeSearchForm"
                        :src="getNavigationIcon('sortCode')"
                        width="25"
                        height="25"
                        aria-label="Navigation Icon"
                      />
                      <v-icon v-else :color="primaryColor" data-qa="addnewpayee-icon-qxbjou">
                        mdi-sync
                      </v-icon>
                    </v-avatar>
                  </v-row>
                </v-flex>
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-2" data-qa="addnewpayee-flex-gtg03">
                  <v-row no-gutters data-qa="addnewpayee-row-lvxwf">
                    <font
                      v-if="!enableSortCodeSearchForm"
                      class="text-h5 font-weight-light white--text"
                    >
                      <span v-if="appSettings.enableNominatedAccountFeatures && appSettings.enablePaymentsOnlyToNominatedAccounts" data-qa="addnewpayee-span-68fi1"> {{ $t("addNewPayee.ownAccountTitle") }} </span>
                      <span v-else data-qa="addnewpayee-span-t92fpg"> {{ $t("addNewPayee.title") }} </span>
                    </font>
                    <font
                      v-else
                      class="text-h5 font-weight-light white--text"
                    >
                      Sort Code
                    </font>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <!-- A D D  N E W  P A Y E E  C A R D -->
    <v-flex
      xs12
      sm12
      md12
      lg12
      xl12
      class="payee--content-padding payee--overlayCardFlex"
      data-qa="addnewpayee-flex-i8mr1"
    >
      <v-layout row wrap class="payee--content-padding" data-qa="addnewpayee-layout-3hmdj">
        <v-col cols="12" class="pt-0 hidden-md-and-up" data-qa="addnewpayee-col-0kieoq">
          <list-payee-btn
            :text="listPayeeText"
            @click="gotoManagePayee"
          />
        </v-col>
        <v-flex
          xs11
          sm11
          md8
          lg8
          xl8
          data-qa="addnewpayee-flex-r0egc"
        >
          <v-card v-show="!enableSortCodeSearchForm" data-qa="addnewpayee-card-nwo1ab">
            <v-tabs v-if="showTabs" v-model="selectedAccountType" class="pb-6 pt-6 pl-8" :color="primaryColor" data-qa="addnewpayee-tabs-ptoeiq">
              <v-tabs-slider
                :color="primaryColor"
                data-qa="addnewpayee-tabs-slider-blheqb"
              />
              <v-tab
                v-for="item in totalTabs"
                :key="item"
                :class="'font-weight-bold'"
                style="text-transform: none;"
                @change="resetForm(); isPristine()"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="selectedAccountType" :color="primaryColor" data-qa="addnewpayee-tabs-items-r6q04dm">
              <v-tab-item
                :color="primaryColor"
                data-qa="addnewpayee-tab-item-kei7b"
              >
                <v-flex class="mx-4" data-qa="addnewpayee-flex-22kkij">
                  <v-form ref="samePayeeForm" v-model="samePayeeForm" data-qa="addnewpayee-form-l6vwr">
                    <v-row class="pa-4">
                      <v-flex class="pt-2 px-3" xs12 sm12 md8 lg8 xl8 data-qa="addnewpayee-flex-7xic2p">
                        <v-text-field
                          v-model="samePayeeName"
                          :label="$t('addNewPayee.payeeName')"
                          filled
                          :color="primaryColor"
                          :rules="[rules.isAlphaNumericRule]"
                          :maxlength="payeeNameMaxlength.sameBank
                            ? payeeNameMaxlength.sameBank
                            : false"
                          data-qa="addnewpayee-text-field-mlkmoa"
                          class="transferFunds--custom-textfield"
                          @keyup.enter="!enableSameAcc && onAddPayee()"
                          @input="isPristine()"
                        />
                      </v-flex>
                      <v-flex class="px-3" xs12 sm12 md8 lg8 xl8 data-qa="addnewpayee-flex-tsn3hm">
                        <v-text-field
                          v-model="sameAccNumber"
                          :label="text.accountLabel"
                          filled
                          type="password"
                          on-copy="return false"
                          onpaste="return false"
                          :color="primaryColor"
                          :rules="[rules.requiredRule]"
                          data-qa="addnewpayee-text-field-0bt6pd"
                          class="transferFunds--custom-textfield"
                          autocomplete="off"
                          @input="isValidFormat(sameAccNumber); isPristine()"
                          @keydown="$formatter.validateNumberInput($event)"
                          @keyup.enter="!enableSameAcc && onAddPayee()"
                        />
                      </v-flex>
                      <v-flex class="px-3" xs12 sm12 md8 lg8 xl8 data-qa="addnewpayee-flex-eaci9b">
                        <v-text-field
                          v-model="sameConfirmAccNumber"
                          :label="text.confirmAccountLabel"
                          filled
                          on-copy="return false"
                          onpaste="return false"
                          :color="primaryColor"
                          :rules="[rules.requiredRule]"
                          :error="
                            isNumberMatched(sameAccNumber, sameConfirmAccNumber)
                          "
                          :error-messages="
                            isNumberMatched(sameAccNumber, sameConfirmAccNumber)
                              ? $t('addNewPayee.errorMsgAccNumMatch')
                              : ''
                          "
                          data-qa="addnewpayee-text-field-billip"
                          class="transferFunds--custom-textfield"
                          @keydown="$formatter.validateNumberInput($event)"
                          @keyup.enter="!enableSameAcc && onAddPayee()"
                          @input="isPristine()"
                        />
                      </v-flex>
                    </v-row>
                    <v-row no-gutters justify="start" class="pa-2" data-qa="addnewpayee-row-ry8ol">
                      <v-flex class="mx-2 pb-6" sm6 md5 lg3 data-qa="addnewpayee-flex-qdx8dr">
                        <v-btn
                          :color="primaryColor"
                          :disabled="enableSameAcc"
                          class="white--text text-capitalize py-2 px-4"
                          data-qa="addnewpayee-btn-9jv91"
                          @click="onAddPayee"
                        >
                          {{ appSettings.enableNominatedAccountFeatures && appSettings.enablePaymentsOnlyToNominatedAccounts ?
                            $t("addNewPayee.ownAccountTitle") :
                            $t("addNewPayee.addPayeeBtn") }}
                        </v-btn>
                      </v-flex>
                    </v-row>
                  </v-form>
                </v-flex>
              </v-tab-item>
              <v-tab-item
                :color="primaryColor"
                data-qa="addnewpayee-tab-item-9bdwb"
              >
                <v-flex :class="appSettings.enableSameBankPayee ? 'mx-4' : 'mx-4 pt-6'" data-qa="addnewpayee-flex-b3y6bc">
                  <v-flex v-if="appSettings.enableAddInternationalPayee || (appSettings.enableSwiftPayee && !isSmeLogin)" class="pl-4" data-qa="addnewpayee-flex-72knyb">
                    <v-layout row wrap data-qa="addnewpayee-layout-k6bbrj">
                      <!-- <v-flex xs12 sm12 md12 lg3 xl3 class="pt-1 hidden-lg-and-up" data-qa="addnewpayee-flex-bs5zgg">
                        <v-card-subtitle class="subtitle-1 font-weight-medium pl-0" data-qa="addnewpayee-card-subtitle-zc925">
                          Beneficiary Type:
                        </v-card-subtitle>
                      </v-flex>
                      <v-card-subtitle class="subtitle-1 font-weight-medium pl-0 pr-1 pt-5 hidden-md-and-down" data-qa="addnewpayee-card-subtitle-5r2z67">
                        Beneficiary Type:
                      </v-card-subtitle> -->
                      <v-flex v-if="!isSmeLogin" xs12 sm12 md12 lg9 xl9 class="mt-n6 mt-lg-auto mt-xl-auto" data-qa="addnewpayee-flex-39xbt">
                        <v-radio-group
                          v-model="isDefaultPayee"
                          row
                          data-qa="addnewpayee-radio-group-knepj"
                          @change="resetOtherPayeeForm"
                        >
                          <v-radio
                          v-if="!isSmeLogin"
                            label="Domestic"
                            value="UKFPS"
                            :color="secondaryColor"
                            data-qa="addnewpayee-radio-n4ux7s"
                          />
                          <v-radio
                            v-if="appSettings.enableAddInternationalPayee"
                            label="SEPA"
                            value="SEPA"
                            :color="secondaryColor"
                            data-qa="addnewpayee-radio-fwm7ss"
                          />
                          <v-radio
                            v-if="appSettings.enableSwiftPayee"
                            label="SWIFT"
                            value="SWIFT"
                            :color="secondaryColor"
                            data-qa="addnewpayee-radio-n4ux7s"
                          />
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-form
                    v-if="isDefaultPayee === 'SWIFT'"
                    ref="otherPayeeSWIFTForm"
                    v-model="isSWIFTFormValid"
                  >
                    <v-row class="pa-4">
                      <!-- Payee Name-->
                      <v-flex xs12 sm12 md8 lg8 xl8 class="px-3 pt-2">
                        <v-text-field
                          v-model="swiftPayee.selectedPayeeName"
                          :color="primaryColor"
                          :label="$t('swiftPayments.payeeName')"
                          :rules="[rules.requiredRule, rules.validateName]"
                          filled
                          :maxlength="payeeNameMaxLen"
                          class="transferFunds--custom-textfield"
                        />
                      </v-flex>
                      <!--Checkbox-->
                      <!--To Account-->
                      <v-flex xs12 sm12 md8 lg8 xl8 class="px-3 pt-2">
                        <v-checkbox
                          v-model="swiftPayee.selectedIBANValue"
                          label="IBAN (eg GB36MODL08888800227919)"
                          class="ma-0 pa-0 test"
                        />
                        <v-text-field
                          ref="toAccField"
                          v-model="swiftPayee.selectedToAccount"
                          :label="swiftPayee.selectedIBANValue ? $t('swiftPayments.selectPayeeLabelIBAN') : $t('swiftPayments.selectPayeeLabel')"
                          :color="primaryColor"
                          :rules="[
                            rules.requiredRule,
                            rules.swiftToAccountNumericRule,
                          ]"
                          :error="isInvalidIBAN"
                          :error-messages="
                            isInvalidIBAN
                              ? $t('internationalPayments.deriveBICError')
                              : ''
                          "
                          :maxlength="toAccMaxLength"
                          filled
                          class="transferFunds--custom-textfield ma-0 pa-0"
                          on-copy="return false"
                          onpaste="return false"
                          @keydown="
                            $formatter.validateNumberInput($event)
                          "
                          @input="clearBICError"
                          @blur="swiftPayee.selectedIBANValue && getBICFromIBAN()"
                        />
                      </v-flex>
                      <!--BIC/Swift-->
                      <v-flex xs12 sm12 md8 lg8 xl8 class="px-3 pt-2">
                        <v-text-field
                          ref="swiftBicCode"
                          v-model="swiftPayee.selectedBicCode"
                          :readonly="swiftPayee.selectedIBANValue"
                          :color="primaryColor"
                          :label="
                            $t('swiftPayments.BICSwift')
                          "
                          :rules="[rules.requiredRule]"
                          :error="isInvalidBic"
                          :error-messages="
                            isInvalidBic
                              ? $t('internationalPayments.invalidBICError')
                              : ''
                          "
                          max-height="auto"
                          filled
                          :class="swiftPayee.selectedIBANValue ? 'transferFunds--custom-disabled-textfieldb' : 'transferFunds--custom-textfield'"
                          @blur="!swiftPayee.selectedIBANValue && swiftPayee.selectedBicCode && setPayeeBankDetails(swiftPayee.selectedBicCode)"
                          @keydown="clearBICFieldError"
                        />
                      </v-flex>
                      <v-flex xs12 sm12 md8 lg8 xl8 class="px-3 pt-2">
                        <v-select
                          v-model="swiftPayee.selectedCurrencyCode"
                          :items="currencyTypes"
                          :label="$t('swiftPayments.currency')"
                          :color="primaryColor"
                          max-height="auto"
                          autocomplete
                          :rules="[rules.requiredRule]"
                          filled
                          class="transferFunds--custom-textfield"
                        />
                      </v-flex>
                      <!-- Country of payee's bank -->
                      <v-flex xs12 sm12 md8 lg8 xl8 class="px-3 pt-2">
                        <v-select
                          v-model="swiftPayee.selectedCountryCode"
                          :items="listCountryCodes"
                          :label="$t('swiftPayments.payeeCountry')"
                          :color="primaryColor"
                          max-height="auto"
                          item-text="codeDescription"
                          item-value="codeReference"
                          autocomplete
                          :rules="[rules.requiredRule]"
                          filled
                          class="transferFunds--custom-textfield"
                        />
                      </v-flex>
                      <v-flex xs12 sm12 md8 lg8 xl8 class="px-3 pt-2">
                        <v-text-field
                          v-model="swiftPayee.town"
                          :color="primaryColor"
                          :label="
                            $t('swiftPayments.payeeTown')
                          "
                          :rules="[rules.requiredRule]"
                          filled
                          :maxlength="35"
                          class="transferFunds--custom-textfield"
                        />
                      </v-flex>
                      <v-flex xs12 sm12 md8 lg8 xl8 class="px-3 pt-2">
                        <v-text-field
                          v-model="swiftPayee.postCode"
                          :color="primaryColor"
                          :label="
                            $t('swiftPayments.payeePostalCode')
                          "
                          :rules="[rules.requiredRule]"
                          filled
                          :maxlength="16"
                          class="transferFunds--custom-textfield"
                        />
                      </v-flex>
                      <v-flex class="px-3 font-weight-bold" xs12 sm12 md11 lg8 xl8>
                        <SupplementaryDocuments
                          v-model="supplementaryDocuments"
                          :required="swiftSupplementaryConfig.required"
                          :max-file-size-in-m-b="swiftSupplementaryConfig.maxFileSizeInMB"
                          :max-file-upload-count="swiftSupplementaryConfig.maxFileUploadCount"
                          :valid-file-types="swiftSupplementaryConfig.validFileTypes"
                          class="pt-2"
                        />
                      </v-flex>
                      <v-flex no-gutters justify="start" class="px-2 pt-2" xs12 sm12 md11 lg8 xl8>
                        <v-flex class="mx-2 pb-6" lg3>
                          <v-btn
                            :color="primaryColor"
                            :disabled="isAddSwiftPayeeDisabled"
                            class="white--text text-capitalize py-2 px-4"
                            @click="onAddPayee('SWIFT')"
                          >
                            {{ $t("addNewPayee.addPayeeBtn") }}
                          </v-btn>
                        </v-flex>
                      </v-flex>
                    </v-row>
                  </v-form>
                  <v-form
                    v-show="!enableSortCodeSearchForm"
                    v-if="isDefaultPayee === 'UKFPS' && !enableUDFBeneficiaryForAddPayee"
                    ref="otherPayeeUKFPSForm"
                    v-model="isUKFPSFormValid"
                    data-qa="addnewpayee-form-j6j8jb"
                  >
                    <v-row class="pa-4 addNewPayee--textfield-bgColor" data-qa="addnewpayee-row-y32i4d">
                      <v-flex class="pt-2 px-3" xs12 sm12 md11 lg8 xl8 data-qa="addnewpayee-flex-qzniz5">
                        <v-text-field
                          v-model="otherPayeeName"
                          :label="$t('addNewPayee.payeeName')"
                          filled
                          :color="primaryColor"
                          :rules="[rules.isAlphaNumericRule]"
                          :maxlength="payeeNameMaxlength.otherBank
                            ? payeeNameMaxlength.otherBank
                            : false
                          "
                          data-qa="addnewpayee-text-field-rzaxtl"
                          @input="isPristine()"
                        />
                      </v-flex>
                      <v-flex class="px-3" xs12 sm12 md11 lg8 xl8 data-qa="addnewpayee-flex-237ve">
                        <v-text-field
                          v-model="otherAccNumber"
                          :label="domesticPayeeText.accountLabel"
                          filled
                          :color="primaryColor"
                          :rules="[rules.requiredRule]"
                          type="password"
                          on-copy="return false"
                          onpaste="return false"
                          data-qa="addnewpayee-text-field-0frlytk"
                          @input="isPristine()"
                          @keydown="$formatter.validateNumberInput($event)"
                        />
                      </v-flex>
                      <v-flex class="px-3" xs12 sm12 md11 lg8 xl8 data-qa="addnewpayee-flex-mikytqr">
                        <v-text-field
                          v-model="otherConfirmAccNumber"
                          :label="domesticPayeeText.confirmAccountLabel"
                          filled
                          on-copy="return false"
                          onpaste="return false"
                          :color="primaryColor"
                          :rules="[rules.requiredRule]"
                          :error="
                            isNumberMatched(otherAccNumber, otherConfirmAccNumber)
                          "
                          :error-messages="
                            isNumberMatched(otherAccNumber, otherConfirmAccNumber)
                              ? $t('addNewPayee.errorMsgAccNumMatch')
                              : ''
                          "
                          data-qa="addnewpayee-text-field-a72pth"
                          @input="isPristine()"
                          @keydown="$formatter.validateNumberInput($event)"
                        />
                      </v-flex>
                      <v-flex class="px-3" xs12 sm12 md11 lg8 xl8 data-qa="addnewpayee-flex-ijn6w">
                        <v-layout class="pa-0" data-qa="addnewpayee-layout-jluwn">
                          <v-flex xs8 sm8 md8 lg8 xl8 data-qa="addnewpayee-flex-fdwm5">
                            <v-text-field
                              v-model="otherSortCode"
                              v-mask="'XX-XX-XX'"
                              :label="$t('addNewPayee.sortCode')"
                              :color="primaryColor"
                              :rules="[rules.requiredWithNoErrRule]"
                              readonly
                              class="transferfunds--nonEditable-textfield"
                              data-qa="addnewpayee-text-field-3uk0g6"
                              @input="isPristine()"
                            />
                          </v-flex>
                          <v-flex xs4 sm4 md4 lg4 xl4 class="text-end" data-qa="addnewpayee-flex-fahcjj">
                            <v-btn
                              :color="primaryColor"
                              outlined
                              class="text-none subtitle-2 font-weight-regular py-2 px-4"
                              data-qa="addnewpayee-btn-qllp8t"
                              @click="onSortcodeSearchBtn"
                            >
                              <v-icon class="material-symbols-outlined" data-qa="addnewpayee-icon-okge3f">
                                search
                              </v-icon>
                              {{ $t("domesticPayments.searchSortCodeBtn") }}
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex class="px-3" xs12 sm12 md11 lg8 xl8 data-qa="addnewpayee-flex-moh6he">
                        <v-text-field
                          v-model="otherPayeeBankName"
                          :label="$t('addNewPayee.bankName')"
                          :color="primaryColor"
                          :rules="[rules.requiredWithNoErrRule]"
                          readonly
                          class="transferfunds--nonEditable-textfield"
                          data-qa="addnewpayee-text-field-4hkq7j"
                          @input="isPristine()"
                        />
                      </v-flex>
                      <v-flex v-if="appSettings.enablePaymentsOnlyToNominatedAccounts" class="px-3 font-weight-bold" xs12 sm12 md11 lg8 xl8 data-qa="addnewpayee-flex-ubruj">
                        {{ $t('addNewPayee.whoseBankAccount') }}
                        <v-radio-group
                          v-model="isOwnAccLinked"
                          :rules="[rules.requiredRule]"
                          row
                          class="font-weight-regular"
                          data-qa="addnewpayee-radio-group-1lzka"
                          @change="isPristine()"
                        >
                          <v-radio
                            :label="$t('addNewPayee.ownAccount')"
                            value="own"
                            :color="secondaryColor"
                            data-qa="addnewpayee-radio-pp98be"
                          />
                          <v-radio
                            :label="$t('addNewPayee.othersAccount')"
                            value="others"
                            :disabled="appSettings.enablePaymentsOnlyToNominatedAccounts"
                            :color="secondaryColor"
                            data-qa="addnewpayee-radio-nn16e4"
                          />
                        </v-radio-group>
                      </v-flex>
                    </v-row>
                    <v-row no-gutters justify="start" class="pa-2" data-qa="addnewpayee-row-f59pxo">
                      <v-flex class="mx-2 pb-6" sm6 md5 lg3 data-qa="addnewpayee-flex-i2iljg">
                        <v-btn
                          :color="primaryColor"
                          :disabled="
                            !isUKFPSFormValid ||
                              isNumberMatched(otherAccNumber, otherConfirmAccNumber)
                          "
                          class="white--text text-capitalize py-2 px-4"
                          data-qa="addnewpayee-btn-4j31ub"
                          @click="onAddPayee('UKFPS')"
                        >
                          {{ appSettings.enableNominatedAccountFeatures && appSettings.enablePaymentsOnlyToNominatedAccounts ?
                            $t("addNewPayee.ownAccountTitle") :
                            $t("addNewPayee.addPayeeBtn") }}
                        </v-btn>
                      </v-flex>
                    </v-row>
                  </v-form>

                  <!-- UKFPS with UDF -->
                  <v-stepper
                    v-if="isDefaultPayee === 'UKFPS' && enableUDFBeneficiaryForAddPayee"
                    v-model="step"
                    alt-labels
                  >
                    <v-row>
                      <v-col cols="12" md="11" lg="8">
                        <v-stepper-header>
                          <template v-for="(stepItem, index) in steps">
                            <v-stepper-step
                              :key="stepItem.id"
                              :step="stepItem.id"
                              :complete="step > stepItem.id"
                              :color="primaryColor"
                              data-qa="addnewpayee-stepper-step-l5msw"
                            >
                              {{ stepItem.label }}
                            </v-stepper-step>
                            <v-divider v-if="index < steps.length - 1" />
                          </template>
                        </v-stepper-header>
                      </v-col>
                    </v-row>

                    <v-stepper-items data-qa="addnewpayee-stepper-items-ad5qaq">
                      <v-stepper-content
                        v-for="item in steps"
                        :key="item.id"
                        :step="item.id"
                      >
                        <v-form
                          v-show="!enableSortCodeSearchForm"
                          v-if="isDefaultPayee === 'UKFPS' && item.id < steps.length"
                          ref="otherPayeeUKFPSForm"
                          v-model="isUKFPSFormValid"
                          data-qa="addnewpayee-form-mt2ijl"
                        >
                          <v-row>
                            <v-col class="pt-2 px-3" cols="12" md="11" lg="8">
                              <v-text-field
                                v-model="otherPayeeName"
                                :label="$t('addNewPayee.payeeName')"
                                filled
                                :color="primaryColor"
                                :rules="[rules.isAlphaNumericRule]"
                                :maxlength="payeeNameMaxlength.otherBank
                                  ? payeeNameMaxlength.otherBank
                                  : false
                                "
                                class="transferFunds--custom-textfield"
                                data-qa="addnewpayee-text-field-glziih"
                                @input="isPristine()"
                              />
                            </v-col>
                            <v-col class="pt-2 px-3" cols="12" md="11" lg="8">
                              <v-text-field
                                v-model="otherAccNumber"
                                :label="domesticPayeeText.accountLabel"
                                filled
                                :color="primaryColor"
                                :rules="[rules.requiredRule]"
                                type="password"
                                on-copy="return false"
                                onpaste="return false"
                                class="transferFunds--custom-textfield"
                                data-qa="addnewpayee-text-field-f7mudf"
                                autocomplete="off"
                                @input="isPristine()"
                                @keydown="$formatter.validateNumberInput($event)"
                              />
                            </v-col>
                            <v-col class="pt-2 px-3" cols="12" md="11" lg="8">
                              <v-text-field
                                v-model="otherConfirmAccNumber"
                                :label="domesticPayeeText.confirmAccountLabel"
                                filled
                                on-copy="return false"
                                onpaste="return false"
                                :color="primaryColor"
                                :rules="[rules.requiredRule]"
                                :error="
                                  isNumberMatched(otherAccNumber, otherConfirmAccNumber)
                                "
                                :error-messages="
                                  isNumberMatched(otherAccNumber, otherConfirmAccNumber)
                                    ? $t('addNewPayee.errorMsgAccNumMatch')
                                    : ''
                                "
                                class="transferFunds--custom-textfield"
                                data-qa="addnewpayee-text-field-b8y8u9"
                                @input="isPristine()"
                                @keydown="$formatter.validateNumberInput($event)"
                              />
                            </v-col>
                            <v-col class="pt-2 px-3" cols="12" md="11" lg="8">
                              <v-row class="pa-0">
                                <v-col cols="8">
                                  <v-text-field
                                    v-model="otherSortCode"
                                    v-mask="'XX-XX-XX'"
                                    :label="$t('addNewPayee.sortCode')"
                                    :color="primaryColor"
                                    :rules="[rules.requiredWithNoErrRule]"
                                    readonly
                                    class="transferfunds--nonEditable-textfield"
                                    data-qa="addnewpayee-text-field-zwav7"
                                    @input="isPristine()"
                                  />
                                </v-col>
                                <v-col cols="4">
                                  <v-btn
                                    :color="primaryColor"
                                    outlined
                                    class="text-none subtitle-2 font-weight-regular py-2 px-4"
                                    data-qa="addnewpayee-btn-dpolvj"
                                    @click="onSortcodeSearchBtn"
                                  >
                                    <v-icon class="material-symbols-outlined" data-qa="addnewpayee-icon-u5k35o">
                                      search
                                    </v-icon>
                                    {{ $t("domesticPayments.searchSortCodeBtn") }}
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col class="pt-2 px-3" cols="12" md="11" lg="8">
                              <v-text-field
                                v-model="otherPayeeBankName"
                                :label="$t('addNewPayee.bankName')"
                                :color="primaryColor"
                                :rules="[rules.requiredWithNoErrRule]"
                                readonly
                                class="transferfunds--nonEditable-textfield"
                                data-qa="addnewpayee-text-field-z6nkm"
                                @input="isPristine()"
                              />
                            </v-col>
                          </v-row>
                          <v-col v-if="appSettings.enablePaymentsOnlyToNominatedAccounts" class="py-3 px-3 font-weight-bold" cols="12" md="11" lg="8">
                            {{ $t('addNewPayee.whoseBankAccount') }}
                            <v-radio-group
                              v-model="isOwnAccLinked"
                              :rules="[rules.requiredRule]"
                              row
                              class="font-weight-regular"
                              data-qa="addnewpayee-radio-group-qc32e"
                              @change="isPristine()"
                            >
                              <v-radio
                                :label="$t('addNewPayee.ownAccount')"
                                value="own"
                                :color="secondaryColor"
                                data-qa="addnewpayee-radio-xuki5i"
                              />
                              <v-radio
                                :label="$t('addNewPayee.othersAccount')"
                                value="others"
                                :disabled="appSettings.enablePaymentsOnlyToNominatedAccounts"
                                :color="secondaryColor"
                                data-qa="addnewpayee-radio-45mrkb"
                              />
                            </v-radio-group>
                          </v-col>
                        </v-form>

                        <v-btn
                          v-if="item.id < steps.length"
                          :color="primaryColor"
                          :disabled="!isUKFPSFormValid || isNumberMatched(otherAccNumber, otherConfirmAccNumber)"
                          class="white--text text-capitalize py-2 px-4"
                          data-qa="addnewpayee-btn-ajoefln"
                          @click="nextStep"
                        >
                          {{ $t('addNewPayee.nextBtn') }}
                        </v-btn>

                        <UdfFormBuilder
                          v-if="item.id > 1"
                          v-model="udfFormData"
                          :form-config="`UDF_AddBeneficiary-${$i18n.locale}`"
                          @form-validity-change="isAddPayeeUdfFormValid = $event"
                        />
                        <v-card-actions v-if="item.id > 1">
                          <v-btn
                            :color="primaryColor"
                            outlined
                            class="text-capitalize py-2 px-4"
                            data-qa="addnewpayee-btn-92ydc5"
                            @click="prevStep"
                          >
                            {{ $t("addNewPayee.previousBtn") }}
                          </v-btn>
                          <v-btn
                            :color="primaryColor"
                            :disabled="!isAddPayeeUdfFormValid"
                            class="white--text text-capitalize py-2 px-4"
                            data-qa="addnewpayee-btn-x6bpa"
                            @click="onAddPayee('UKFPS')"
                          >
                            {{ addPayeeButtonText }}
                          </v-btn>
                        </v-card-actions>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>

                  <!-- SEPA with UDF -->
                  <v-stepper
                    v-if="isDefaultPayee === 'SEPA' && enableUDFBeneficiaryForAddPayee"
                    v-model="step"
                    alt-labels
                  >
                    <v-row>
                      <v-col cols="12" md="11" lg="8">
                        <v-stepper-header>
                          <template v-for="(stepItem, index) in steps">
                            <v-stepper-step
                              :key="stepItem.id"
                              :step="stepItem.id"
                              :complete="step > stepItem.id"
                              :color="primaryColor"
                              data-qa="addnewpayee-stepper-step-wgmi8g"
                            >
                              {{ stepItem.label }}
                            </v-stepper-step>
                            <v-divider v-if="index < steps.length - 1" />
                          </template>
                        </v-stepper-header>
                      </v-col>
                    </v-row>

                    <v-stepper-items data-qa="addnewpayee-stepper-items-5l0ghq">
                      <v-stepper-content
                        v-for="item in steps"
                        :key="item.id"
                        :step="item.id"
                      >
                        <!-- Payee Details -->
                        <v-form
                          v-if="isDefaultPayee === 'SEPA' && item.id < steps.length"
                          ref="otherPayeeSEPAForm"
                          v-model="isSEPAFormValid"
                          data-qa="addnewpayee-form-ksw96n"
                        >
                          <v-row>
                            <v-col v-if="isAddPayeeAddressEnabled"
                              class="pt-2 px-3" cols="12" data-qa="addnewpayee-flex-payeeTitle"
                            >
                              <span class="text-body-1 font-weight-bold">
                                {{ $t("payeeDetails.title") }}
                              </span>
                            </v-col>
                            <v-col
                              class="pt-2 px-3"
                              cols="12"
                              v-bind="colProps"
                            >
                              <v-text-field
                                v-model="otherPayeeSEPA.accountName"
                                :label="$t('internationalPayments.payeeAccountNameLabel')"
                                :color="primaryColor"
                                :rules="[rules.requiredRule]"
                                :maxlength="payeeNameMaxlength.otherBank
                                  ? payeeNameMaxlength.otherBank
                                  : false"
                                filled
                                class="transferFunds--custom-textfield"
                                data-qa="addnewpayee-text-field-tsal3f"
                                @input="isPristine()"
                              />
                            </v-col>
                            <v-col
                              class="pt-2 px-3"
                              cols="12"
                              v-bind="colProps"
                            >
                              <v-text-field
                                v-model="otherPayeeSEPA.reEnteredToAccount"
                                :label="$t('internationalPayments.payeeAccNoLabel')"
                                :color="primaryColor"
                                :rules="[rules.requiredRule]"
                                filled
                                on-copy="return false"
                                onpaste="return false"
                                class="transferFunds--custom-textfield"
                                data-qa="addnewpayee-text-field-8fhnq"
                                @blur="
                                  getBICFromIBAN();
                                  isAddPayeeAddressEnabled && setPayeeCountry()
                                "
                                @keydown="$formatter.validateNumberInput($event, getIBAN())"
                                @input="formatIBAN()"
                              />
                            </v-col>
                            <v-col
                              class="pt-2 px-3"
                              cols="12"
                              v-bind="colProps"
                            >
                              <v-text-field
                                v-model="otherPayeeSEPA.sortCode"
                                :label="$t('internationalPayments.addNewPayee.bicCode')"
                                :color="primaryColor"
                                :rules="[rules.requiredWithNoErrRule]"
                                readonly
                                class="transferfunds--nonEditable-textfield"
                                data-qa="addnewpayee-text-field-7y09i2"
                                @input="isPristine()"
                              />
                            </v-col>
                            <v-col class="pt-2 px-1" cols="12"
                              data-qa="addnewpayee-flex-payeeAddressForm"
                              v-if="isAddPayeeAddressEnabled"
                            >
                              <PayeeAddressDetails
                                v-model="payeeAddressFormData"
                                @form-validity-change="isAddPayeeAddressFormValid = $event"
                              />
                            </v-col>
                            <v-col v-if="appSettings.enablePaymentsOnlyToNominatedAccounts"" class="py-3 px-3 font-weight-bold" cols="12" md="11" lg="8">
                              {{ $t('addNewPayee.whoseBankAccount') }}
                              <v-radio-group
                                v-model="isOwnAccLinked"
                                :rules="[rules.requiredRule]"
                                row
                                class="font-weight-regular"
                                data-qa="addnewpayee-radio-group-hehiu"
                                @change="isPristine()"
                              >
                                <v-radio
                                  :label="$t('addNewPayee.ownAccount')"
                                  value="own"
                                  :color="secondaryColor"
                                  data-qa="addnewpayee-radio-jt584a"
                                />
                                <v-radio
                                  :label="$t('addNewPayee.othersAccount')"
                                  value="others"
                                  :disabled="appSettings.enablePaymentsOnlyToNominatedAccounts"
                                  :color="secondaryColor"
                                  data-qa="addnewpayee-radio-zcj59f"
                                />
                              </v-radio-group>
                            </v-col>

                            <v-col class="pt-2 px-3" cols="12" md="11" lg="8">
                              <SupplementaryDocuments
                                v-if="isSupplementaryDocumentEnabled"
                                v-model="supplementaryDocuments"
                                :required="supplementaryConfig.required"
                                :max-file-size-in-m-b="supplementaryConfig.maxFileSizeInMB"
                                :max-file-upload-count="supplementaryConfig.maxFileUploadCount"
                                :valid-file-types="supplementaryConfig.validFileTypes"
                                class="pt-2"
                              />
                            </v-col>
                          </v-row>
                        </v-form>

                        <v-btn
                          v-if="item.id < steps.length"
                          :color="primaryColor"
                          :disabled="isAddPayeeDisabled"
                          class="white--text text-capitalize py-2 px-4"
                          data-qa="addnewpayee-btn-cb2lgi"
                          @click="nextStep"
                        >
                          {{ $t('addNewPayee.nextBtn') }}
                        </v-btn>

                        <UdfFormBuilder
                          v-if="item.id > 1"
                          v-model="udfFormData"
                          :form-config="`UDF_AddBeneficiary-${$i18n.locale}`"
                          @form-validity-change="isAddPayeeUdfFormValid = $event"
                        />

                        <v-card-actions v-if="item.id > 1" class="mt-4">
                          <v-btn
                            :color="primaryColor"
                            outlined
                            class="text-capitalize py-2 px-4"
                            data-qa="addnewpayee-btn-23xtxj2"
                            @click="prevStep"
                          >
                            {{ $t('addNewPayee.previousBtn') }}
                          </v-btn>
                          <v-btn
                            :color="primaryColor"
                            :disabled="!isAddPayeeUdfFormValid"
                            class="white--text text-capitalize py-2 px-4"
                            data-qa="addnewpayee-btn-1iofg4"
                            @click="onAddPayee('SEPA')"
                          >
                            {{ addPayeeButtonText }}
                          </v-btn>
                        </v-card-actions>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-stepper>
                  <!-- SEPA without UDF -->
                  <v-form
                    v-if="isDefaultPayee === 'SEPA' && !enableUDFBeneficiaryForAddPayee"
                    ref="otherPayeeSEPAForm"
                    v-model="isSEPAFormValid"
                    data-qa="addnewpayee-form-0jc6mn"
                  >
                    <v-row class="pa-4 addNewPayee--textfield-bgColor" data-qa="addnewpayee-row-3j3mbq">
                      <v-flex v-if="isAddPayeeAddressEnabled"
                        class="pt-2 pb-1 px-3" xs12 sm12 md12 lg12 xl12 data-qa="addnewpayee-flex-payeeTitle"
                      >
                        <span class="text-body-1 font-weight-bold">
                          {{ $t("payeeDetails.title") }}
                        </span>
                      </v-flex>
                      <v-flex
                        class="pt-2 px-3"
                        v-bind="flexProps"
                        data-qa="addnewpayee-flex-wdefoo"
                      >
                        <v-text-field
                          v-model="otherPayeeSEPA.accountName"
                          :label="
                            $t('internationalPayments.payeeAccountNameLabel')
                          "
                          :color="primaryColor"
                          :rules="[rules.requiredRule]"
                          :maxlength="payeeNameMaxlength.otherBank
                            ? payeeNameMaxlength.otherBank
                            : false"
                          filled
                          class="transferFunds--custom-textfield"
                          data-qa="addnewpayee-text-field-r5k3bh"
                          @input="isPristine()"
                        />
                      </v-flex>
                      <v-flex
                        class="pt-2 px-3"
                        v-bind="flexProps"
                        data-qa="addnewpayee-flex-ey7v2x"
                      >
                        <v-text-field
                          v-model="otherPayeeSEPA.reEnteredToAccount"
                          :label="
                            $t('internationalPayments.payeeAccNoLabel')
                          "
                          :color="primaryColor"
                          :rules="[rules.requiredRule]"
                          filled
                          on-copy="return false"
                          onpaste="return false"
                          class="transferFunds--custom-textfield"
                          data-qa="addnewpayee-text-field-56j6rd"
                          @blur="
                            getBICFromIBAN();
                            isAddPayeeAddressEnabled && setPayeeCountry()
                          "
                          @keydown="$formatter.validateNumberInput($event, getIBAN())"
                          @input="formatIBAN()"
                        />
                      </v-flex>
                      <v-flex
                        class="pt-2 px-3"
                        v-bind="flexProps"
                        data-qa="addnewpayee-flex-reg6dq"
                      >
                        <v-text-field
                          v-model="otherPayeeSEPA.sortCode"
                          :label="$t('internationalPayments.addNewPayee.bicCode')"
                          :color="primaryColor"
                          :rules="[rules.requiredWithNoErrRule]"
                          readonly
                          class="transferfunds--nonEditable-textfield"
                          data-qa="addnewpayee-text-field-knkz0f"
                          @input="isPristine()"
                        />
                      </v-flex>
                    </v-row>
                    <v-row class="pa-4 addNewPayee--textfield-bgColor"
                      data-qa="addnewpayee-flex-payeeAddressForm"
                      v-if="isAddPayeeAddressEnabled"
                    >
                      <PayeeAddressDetails
                        v-model="payeeAddressFormData"
                        @form-validity-change="isAddPayeeAddressFormValid = $event"
                      />
                    </v-row>
                    <v-flex class="px-3 font-weight-bold" xs12 sm12 md11 lg8 xl8 data-qa="addnewpayee-flex-7phb3r">
                      {{ $t('addNewPayee.whoseBankAccount') }}
                      <v-radio-group
                        v-model="isOwnAccLinked"
                        :rules="[rules.requiredRule]"
                        row
                        class="font-weight-regular"
                        data-qa="addnewpayee-radio-group-j6yt7c"
                        @change="isPristine()"
                      >
                        <v-radio
                          :label="$t('addNewPayee.ownAccount')"
                          value="own"
                          :color="secondaryColor"
                          data-qa="addnewpayee-radio-nhg05c"
                        />
                        <v-radio
                          :label="$t('addNewPayee.othersAccount')"
                          value="others"
                          :disabled="appSettings.enablePaymentsOnlyToNominatedAccounts"
                          :color="secondaryColor"
                          data-qa="addnewpayee-radio-q9w15l"
                        />
                      </v-radio-group>
                    </v-flex>
                    <SupplementaryDocuments
                      v-if="isSupplementaryDocumentEnabled"
                      v-model="supplementaryDocuments"
                      :required="supplementaryConfig.required"
                      :max-file-size-in-m-b="supplementaryConfig.maxFileSizeInMB"
                      :max-file-upload-count="supplementaryConfig.maxFileUploadCount"
                      :valid-file-types="supplementaryConfig.validFileTypes"
                      class="pt-2"
                    />
                    <v-row no-gutters justify="start" class="pa-2" data-qa="addnewpayee-row-z1v5z7">
                      <v-flex class="mx-2 pb-6" lg3 data-qa="addnewpayee-flex-r1d40k">
                        <v-btn
                          :color="primaryColor"
                          :disabled="isAddPayeeDisabled"
                          class="white--text text-capitalize py-2 px-4"
                          data-qa="addnewpayee-btn-w0qls"
                          @click="onAddPayee('SEPA')"
                        >
                          {{ appSettings.enableNominatedAccountFeatures && appSettings.enablePaymentsOnlyToNominatedAccounts ?
                            $t("addNewPayee.ownAccountTitle") :
                            $t("addNewPayee.addPayeeBtn") }}
                        </v-btn>
                      </v-flex>
                    </v-row>
                  </v-form>
                </v-flex>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
          <v-card v-if="enableSortCodeSearchForm" data-qa="addnewpayee-card-wqe7x7">
            <!-- Payees -->
            <v-list v-if="enableSortCodeSearchForm" class="pa-2" data-qa="addnewpayee-list-mftv8t">
              <v-list-item data-qa="addnewpayee-list-item-dsma17">
                <v-list-item-content data-qa="addnewpayee-list-item-content-305ddd">
                  <v-row no-gutters data-qa="addnewpayee-row-xy7b3i">
                    <v-alert
                      icon="mdi-information-outline"
                      class="v-alert--info"
                      data-qa="addnewpayee-alert-qdskqr"
                    >
                      <font class="caption font-weight-regular">
                        {{ $t("domesticPayments.searchSortCodeInfo") }}
                      </font>
                    </v-alert>
                  </v-row>

                  <v-form
                    ref="searchSortCodeForm"
                    v-model="isSortCodeSearchFormValid"
                    data-qa="addnewpayee-form-c181l4"
                  >
                    <v-layout wrap data-qa="addnewpayee-layout-3rvyl7">
                      <v-flex xs12 sm12 md6 lg6 xl6 data-qa="addnewpayee-flex-ymqig">
                        <v-text-field
                          v-model="searchSortCodeForm.bankName"
                          :label="$t('addNewPayee.bankName')"
                          :color="primaryColor"
                          :rules="[
                            searchSortCodeForm.bankName
                              ? rules.minLength(
                                searchSortCodeForm.bankName,
                                searchSortCodeForm.minInputLength
                              )
                              : true,
                          ]"
                          filled
                          required
                          class="transferFunds--custom-textfield"
                          data-qa="addnewpayee-text-field-gz7xv"
                          @input="isPristine()"
                        />
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6 xl6 data-qa="addnewpayee-flex-ps9ux">
                        <v-text-field
                          v-model="searchSortCodeForm.branchName"
                          :label="$t('addNewPayee.branchName')"
                          :color="primaryColor"
                          :rules="[
                            searchSortCodeForm.branchName
                              ? rules.minLength(
                                searchSortCodeForm.branchName,
                                searchSortCodeForm.minInputLength
                              )
                              : true,
                          ]"
                          filled
                          class="transferFunds--custom-textfield"
                          data-qa="addnewpayee-text-field-fsriwk"
                          @input="isPristine()"
                        />
                      </v-flex>
                      <v-flex xs12 sm12 md6 lg6 xl6 data-qa="addnewpayee-flex-4vs7m6">
                        <v-text-field
                          v-model="searchSortCodeForm.sortCode"
                          v-mask="'XX-XX-XX'"
                          :label="$t('addNewPayee.sortCodeOptional')"
                          :color="primaryColor"
                          filled
                          class="transferFunds--custom-textfield"
                          data-qa="addnewpayee-text-field-lgkx4"
                          @input="isPristine()"
                        />
                      </v-flex>
                    </v-layout>
                    <v-row no-gutters justify="start" data-qa="addnewpayee-row-9iig5k">
                      <v-card-actions data-qa="addnewpayee-card-actions-8snjd8">
                        <v-btn
                          :color="primaryColor"
                          outlined
                          class="text-capitalize py-2 px-4"
                          data-qa="addnewpayee-btn-w3nvtv"
                          @click="onClosePayeeDrawer"
                        >
                          {{ $t('common.back') }}
                        </v-btn>
                        <v-btn
                          :color="primaryColor"
                          :disabled="isSearchDataValid()"
                          class="white--text text-capitalize py-2 px-4"
                          data-qa="addnewpayee-btn-i12wp"
                          @click="onSearchSortCode"
                        >
                          {{ $t("domesticPayments.searchBtn") }}
                        </v-btn>
                      </v-card-actions>
                    </v-row>
                  </v-form>
                </v-list-item-content>
              </v-list-item>
              <font
                v-if="sortCodeResults.length"
                class="pl-4 text-h6 font-weight-light"
              >
                {{ $t("domesticPayments.searchResultsTitle") }}
              </font>
              <div v-if="sortCodeResults.length" data-qa="addnewpayee-div-5smmv">
                <template v-for="(data, index) in sortCodeResults">
                  <v-list-item :key="data.nationalid" data-qa="addnewpayee-list-item-g4asn">
                    <v-list-item-content data-qa="addnewpayee-list-item-content-sveo4f">
                      <v-flex xs8 sm8 md8 lg8 xl8 data-qa="addnewpayee-flex-6mkbf">
                        <v-list-item-title data-qa="addnewpayee-list-item-title-o12r9q">
                          <font class="body-2 font-weight-light">
                            {{ convertToCapitalisedSentence(data.instname) }}
                          </font>
                        </v-list-item-title>
                        <v-list-item-subtitle data-qa="addnewpayee-list-item-subtitle-vgenhg">
                          <font class="caption">
                            {{ convertToCapitalisedSentence(data.branchinfo) }},
                            {{ convertToCapitalisedSentence(data.streetaddr3) }}
                          </font>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle data-qa="addnewpayee-list-item-subtitle-hlkrat">
                          <font class="caption font-weight-bold">
                            {{ $t("domesticPayments.sortCodeLabel") }}
                          </font><font class="caption font-weight-bold">
                            {{ maskSortCode(data.nationalid) }}
                          </font>
                        </v-list-item-subtitle>
                      </v-flex>
                      <v-flex xs4 sm4 md4 lg4 xl4 class="text-end" data-qa="addnewpayee-flex-tp91z">
                        <v-btn
                          :color="primaryColor"
                          outlined
                          class="text-none py-2 px-4"
                          data-qa="addnewpayee-btn-f4y2e"
                          @click="onSortCodeSelect(data)"
                        >
                          {{ $t("domesticPayments.selectBtn") }}
                        </v-btn>
                      </v-flex>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider
                    v-if="showDivider(index, sortCodeResults)"
                    :key="index"
                    data-qa="addnewpayee-divider-z7zk7r"
                  />
                </template>
              </div>
              <div
                v-if="
                  !searchSortCodeForm.isSearchAvailable &&
                    !sortCodeResults.length
                "
                data-qa="addnewpayee-div-ktzxipq"
              >
                <font class="pl-4 text-h6 font-weight-light">
                  {{ $t("domesticPayments.searchResultsTitle") }}
                </font>
                <v-list-item data-qa="addnewpayee-list-item-z6kxw9">
                  <font class="body-2 font-weight-light">
                    {{ $t("domesticPayments.noSortCode") }}
                  </font>
                </v-list-item>
              </div>
            </v-list>
          </v-card>
        </v-flex>
        <v-flex
          v-if="!enableSortCodeSearchForm"
          class="mt-4 px-3 flex-start hidden-sm-and-down"
          cols="3"
          data-qa="addnewpayee-flex-rb6re"
        >
          <list-payee-btn
            :text="listPayeeText"
            @click="gotoManagePayee"
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- OTP Section for create beneficiary AC -->
    <Modal
      v-if="
        showOTPScreen &&
          (enableOTPToUKFPS || enableOTPToSEPA || enableOTPToSameBank)
      "
      :config="beneficiaryOtpConfig"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="addnewpayee-span-2hrgo">
        <OtpInput :otp-config="beneficiaryOtpSettings" />
      </span>
    </Modal>
    <ConfirmAddNewPayee v-if="beneficiaryConfirmModal" :config="confirmData" />
    <ConfirmExit
      v-if="isLeavingRoute"
      @isLeavingRoute="proceedLeave"
      @isNotLeavingRoute="cancelLeave"
    />
  </v-flex>
</template>

<script>
import '@/styles/pages/payee.scss'
import { mask } from 'vue-the-mask'
import commonService from '@/service/commonService.js'
import UKFPSpayemntTemplate from '@/plugins/UKFPSconfig'
import SEPApayemntTemplate from '@/plugins/SEPAconfig'
import '@/styles/pages/transferFunds.scss'
import event from '@/util/event'
import Loader from '../../components/common/Loader.vue'
import SupplementaryDocuments from '@/views/payments/InterBankPayments/common/SupplementaryDocuments'
import { v4 as uuidv4 } from 'uuid'
import UdfFormBuilder from '../../components/common/UdfFormBuilder.vue'
import PayeeAddressDetails from './PayeeAddressDetails.vue'

const payeeBankType = {
  SAMEBANK: 0,
  OTHERBANK: 1
}

export default {
  name: 'AddNewPayee',
  directives: { mask },
  components: {
    Loader,
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput: () => import('@/components/common/OtpInput.vue'),
    ConfirmAddNewPayee: () => import('@/views/payee/ConfirmAddNewPayee.vue'),
    ConfirmExit: () => import('@/components/common/ConfirmExit.vue'),
    'list-payee-btn': () => import('@/views/common/buttons/WrappedButton.vue'),
    SupplementaryDocuments,
    UdfFormBuilder,
    PayeeAddressDetails
  },
  beforeRouteLeave (to, from, next) {
    if (this.addNewPayeeDataSanity && !this.isAddNewPayeeAccComplete) {
      if (this.to) {
        next()
      } else if (this.isLogout) {
        this.to = to
        this.isLeavingRoute = false
        this.$router.push('/login')
      } else {
        this.to = to
        this.isLeavingRoute = true
      }
    } else {
      next()
    }
  },
  data () {
    return {
      UKFPSpayemntTemplate,
      SEPApayemntTemplate,
      selectedAccountType: 0,
      isUKFPSFormValid: false,
      isSEPAFormValid: false,
      showOTPScreen: false,
      showTabs: true,
      sortCodesList: ['010201', '010202'],
      loading: false,
      items: [],
      search: null,
      select: null,
      numberCheck: (v) =>
        new RegExp('^(\\d*\\.)?\\d+$').test(v) ||
        this.$t('errors.common.invalidInput'),
      ibanCheck: (v) =>
        new RegExp('^[A-Z]{2}[A-Z0-9]+$').test(v) ||
        this.$t('errors.common.invalidInput'),
      isDefaultPayee: 'SEPA',
      isOwnAccLinked: null,
      loaderEnabled: false,
      sameAccNumber: '',
      sameConfirmAccNumber: '',
      samePayeeName: '',
      otherAccNumber: '',
      otherConfirmAccNumber: '',
      otherPayeeName: '',
      otherSortCode: '',
      otherPayeeBankName: '',
      enableSortCodeSearchForm: false,
      isSortCodeSearchFormValid: false,
      appSettings: this.$appSettings.defaultConfigurations.nominatedAccounts,
      searchSortCodeForm: {
        sortCode: '',
        branchName: '',
        bankName: '',
        isSearchAvailable: true,
        minInputLength: 5
      },
      beneficiaryOtpConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      beneficiaryOtpSettings: {
        resetPasswordTime:
          this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      disableAddPayeeBtn: true,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      corporateId: '',
      userId: '',
      samePayeeForm: '',
      beneficiaryConfirmModal: false,
      sortCodeResults: [],
      otherPayeeSEPA: {
        sortCode: '',
        toAccount: '',
        accountName: '',
        reEnteredToAccount: ''
      },
      payeeNameMaxlength: {
        sameBank: this.$appSettings.defaultConfigurations.payeeNameMaxlength.intraBank,
        otherBank: this.$appSettings.defaultConfigurations.payeeNameMaxlength.interBank
      },
      enableOTPToUKFPS:
        this.$appSettings.defaultConfigurations.enableOTPManagePayee
          .addUKFPSPayee,
      enableOTPToSEPA:
        this.$appSettings.defaultConfigurations.enableOTPManagePayee
          .addSEPAPayee,
      enableOTPToSameBank:
        this.$appSettings.defaultConfigurations.enableOTPManagePayee
          .addIntraPayee,
      enableOTPToSWIFT:
        this.$appSettings.defaultConfigurations.enableOTPManagePayee
          .addSWIFTPayee,
      enableEBAVCheckForAddPayee: this.$appSettings.defaultConfigurations.enableEBAVCheckForAddPayee,
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      totalTabs: [
        this.$t('termDepositActions.listAC.internalButtonLabel'),
        this.$t('termDepositActions.listAC.externalButtonLabel')
      ],
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        requiredWithNoErrRule: (v) => Boolean(v) || '',
        minLength: (value, min) => (value && value.length >= min) || '',
        isAlphaNumericRule: (v) => {
          if (v) {
            return (
              new RegExp('^(?![0-9]+$)(?![!@#$%^&*]+$)[a-zA-Z0-9!@#$%^&*]+(?!\\s$)').test(v.trim()) ||
              this.$t('errors.common.invalidInput')
            )
          } else return 'Required Field'
        },
        account: (v) => this.checkAccountInput(v),
        swiftToAccountNumericRule: (v) => {
          if (v) {
            return (
              new RegExp('^([^ !@#\\$%\\^&\\*][a-zA-Z0-9]*)$', 'g').test(v) ||
              this.$t('errors.common.invalidInput')
            )
          } else return 'Required Field'
        },
        validateName: (v) => {
          if (v) {
            return (
              new RegExp('^([^!@#\\$%\\^&\\*][a-zA-Z\\.\'\\s]*)$', 'g').test(v) ||
              this.$t('errors.common.invalidInput')
            )
          } else return 'Required Field'
        }
      },
      isAddNewPayeeAccComplete: false,
      addNewPayeeDataSanity: false,
      isLeavingRoute: false,
      to: null,
      isLogout: false,
      text: {
        accountLabel: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? this.$t('addNewPayee.accNoIBAN') : this.$t('addNewPayee.accNo'),
        confirmAccountLabel: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay ? this.$t('addNewPayee.confirmAccNoIBAN') : this.$t('addNewPayee.confirmAccNo')
      },
      domesticPayeeText: {
        accountLabel: this.$t('addNewPayee.accNo'),
        confirmAccountLabel: this.$t('addNewPayee.confirmAccNo')
      },
      enableIBANAccountNumberDisplay: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay,
      enableUDFBeneficiaryForAddPayee: this.$appSettings.defaultConfigurations.enableUDFBeneficiaryForAddPayee,
      disableConfirmBtn: true,
      step: 1,
      steps: [
        { id: 1, label: this.$t('addNewPayee.payeeDetailsLabel') },
        { id: 2, label: this.$t('addNewPayee.otherDetailsLabel') }
      ],
      isAddPayeePermitted: {
        sameBank: false,
        otherBank: false
      },
      supplementaryDocuments: [],
      payeeBankType: {},
      isSWIFTFormValid: false,
      swiftPayee: {
        selectedCountryCode: '',
        selectedCurrencyCode: '',
        selectedPayeeName: '',
        selectedIBANValue: false,
        selectedToAccount: '',
        selectedBicCode: '',
        town: '',
        postCode: ''
      },
      listCountryCodes: [],
      isInvalidIBAN: false,
      isInvalidBic: false,
      toAccMaxLength: this.$appSettings.defaultConfigurations.fundTransferQuickPayToAccMaxlengthIBAN,
      payeeNameMaxLen: this.$appSettings.defaultConfigurations.payeeNameMaxlength.swift,
      currencyTypes: this.$appSettings.swiftCurrencyFormats,
      udfFormData: null,
      isAddPayeeUdfFormValid: false,
      payeeAddressFormData: null,
      isAddPayeeAddressFormValid: true
    }
  },
  computed: {
    enableSameAcc () {
      return !this.samePayeeForm
    },
    listPayeeText () {
      return this.appSettings.enableNominatedAccountFeatures &&
        this.appSettings.enablePaymentsOnlyToNominatedAccounts
        ? this.$t('addNewPayee.nominatedAccListPayee')
        : this.$t('addNewPayee.listPayee')
    },
    supplementaryConfig () {
      const { SEPA } = this.$appSettings.defaultConfigurations.payeeSupplementaryDocuments
      return {
        enabled: SEPA.enabled,
        required: SEPA.required,
        maxFileSizeInMB: SEPA.maxFileSizeInMB,
        maxFileUploadCount: SEPA.maxFileUploadCount,
        validFileTypes: SEPA.validFileTypes
      }
    },
    swiftSupplementaryConfig () {
      const { SWIFT } = this.$appSettings.defaultConfigurations.payeeSupplementaryDocuments
      return {
        enabled: SWIFT.enabled,
        required: SWIFT.required,
        maxFileSizeInMB: SWIFT.maxFileSizeInMB,
        maxFileUploadCount: SWIFT.maxFileUploadCount,
        validFileTypes: SWIFT.validFileTypes
      }
    },
    isSupplementaryDocumentEnabled () {
      return this.isSmeLogin && this.supplementaryConfig.enabled
    },
    hasValidSupplementaryDocuments () {
      const { required } = this.$appSettings.defaultConfigurations.payeeSupplementaryDocuments.SEPA
      const documents = this.supplementaryDocuments || []

      const allDocumentsValid = documents.every(doc => !doc.error)
      const hasDocuments = documents.length > 0

      if (!this.isSupplementaryDocumentEnabled) {
        return true
      }
      if (required) {
        return hasDocuments && allDocumentsValid
      }
      return allDocumentsValid
    },
    hasValidSwiftSupplementaryDocuments () {
      const { required } = this.$appSettings.defaultConfigurations.payeeSupplementaryDocuments.SWIFT
      const documents = this.supplementaryDocuments || []

      const allDocumentsValid = documents.every(doc => !doc.error)
      const hasDocuments = documents.length > 0

      if (required) {
        return hasDocuments && allDocumentsValid
      }
      return allDocumentsValid
    },
    isAddPayeeDisabled () {
      return !this.isSEPAFormValid || !this.hasValidSupplementaryDocuments || !this.isAddPayeeAddressFormValid
    },
    isAddPayeeAddressEnabled () {
      return this.appSettings.enableInternationalPayeeAddressFields && this.isSmeLogin
    },
    colProps () {
      return this.isAddPayeeAddressEnabled
        ? { md: 6, lg: 6 }
        : { md: 11, lg: 8 }
    },
    flexProps () {
      return {
        class: [
          'xs12',
          'sm12',
          ...(this.isAddPayeeAddressEnabled
            ? ['md6', 'lg6', 'xl6']
            : ['md8', 'lg8', 'xl8'])
        ]
      }
    },
    isAddSwiftPayeeDisabled () {
      return !this.isSWIFTFormValid || !this.hasValidSwiftSupplementaryDocuments
    },
    addPayeeButtonText () {
      return this.appSettings.enableNominatedAccountFeatures && this.appSettings.enablePaymentsOnlyToNominatedAccounts
        ? this.$t('addNewPayee.ownAccountTitle')
        : this.$t('addNewPayee.addPayeeBtn')
    }
  },
  watch: {
    search (val) {
      val && val !== this.select && this.querySelections(val)
    }
  },
  created () {
    this.payeeBankType = payeeBankType
    this.selectedAccountType = payeeBankType.SAMEBANK
    // Only for SME - Check if the selected account has delete permissions
    const permissions = this.$store.getters['profileStore/profileData']?.permissions
    this.isAddPayeePermitted.sameBank = (this.isSmeLogin && this.enableRoleBasedAccess)
      ? permissions?.includes('ADD_AND_DELETE_SAME_BANK_PAYEES')
      : true
    this.isAddPayeePermitted.otherBank = (this.isSmeLogin && this.enableRoleBasedAccess)
      ? (permissions?.includes('ADD_AND_DELETE_UKFPS_PAYEES') || permissions?.includes('ADD_AND_DELETE_SEPA_PAYEES'))
      : true
    this.getGenericCodes()
    this.getActiveCurrencyFromService()
    // If both tabs are enabled, default tab = 0
    if ((this.isSmeLogin && this.enableRoleBasedAccess)
      ? this.isAddPayeePermitted.sameBank
      : this.appSettings.enableSameBankPayee
    ) {
      this.selectedAccountType = payeeBankType.SAMEBANK
      this.showTabs = true
    } else {
      this.selectedAccountType = payeeBankType.OTHERBANK
      this.showTabs = false
    }

    if (this.isSmeLogin && this.enableRoleBasedAccess) {
      if (!this.isAddPayeePermitted.sameBank && this.isAddPayeePermitted.otherBank) {
        this.totalTabs.splice(0, 1)
      }
      if (this.isAddPayeePermitted.sameBank && !this.isAddPayeePermitted.otherBank) {
        this.totalTabs.splice(1, 1)
      }
    }

    /** Route param will have the tab idx from Manage Payee screen. Navigate to appropriate tab (Same/Other) based on this value  */
    if (this.$route.params && this.$route.params.comingFromTab) {
      this.selectedAccountType = this.$route.params.comingFromTab
    }
    event.$on('isValid', (arg) => {
      this.disableConfirmBtn = !arg
    })
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid && this.showOTPScreen &&
        (this.enableOTPToUKFPS || this.enableOTPToSEPA || this.enableOTPToSameBank || this.enableOTPToSWIFT)) {
        this.createBeneficiaryAccount()
      } else {
        this.beneficiaryOtpConfig.enableSave = true
      }
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
    this.userId = JSON.parse(sessionStorage.getItem('customerCode')) || JSON.parse(sessionStorage.getItem('userId'))
    this.corporateId = JSON.parse(sessionStorage.getItem('corporateId'))
  },
  mounted () {
    if (this.appSettings.enablePaymentsOnlyToNominatedAccounts) this.isOwnAccLinked = 'own'
  },
  methods: {
    getNavigationIcon (type) {
      switch (type) {
        case 'deposit':
          return this.getSvgIconSrc('Deposit2')
        case 'sortCode':
          return this.getSvgIconSrc('Payee_Drawer')
        default:
          return this.getSvgIconSrc('Deposit2')
      }
    },
    onSortcodeSearchBtn () {
      this.enableSortCodeSearchForm = true
    },
    setPayeeCountry () {
      event.$emit('setCountry', this.otherPayeeSEPA.reEnteredToAccount.slice(0, 2))
    },
    getIBAN () {
      if (this.otherPayeeSEPA.reEnteredToAccount && this.otherPayeeSEPA.reEnteredToAccount.length) {
        return `IBAN-${this.otherPayeeSEPA.reEnteredToAccount.length}`
      }
    },
    formatIBAN () {
      this.otherPayeeSEPA.reEnteredToAccount = this.otherPayeeSEPA.reEnteredToAccount.toUpperCase()
      if (this.otherPayeeSEPA.reEnteredToAccount && this.otherPayeeSEPA.reEnteredToAccount.length && this.otherPayeeSEPA.reEnteredToAccount.length > 3) {
        let data = ''
        data = this.otherPayeeSEPA.reEnteredToAccount.replace(/\s+/g, '')
        const res = data.substr(0, 4) + ' ' + data.substr(4, 4) + ' ' + data.substr(8, 4) + ' ' + data.substr(12, 4) + ' ' + data.substr(16, 4) + ' ' + data.substr(20, 4) + ' ' + data.substr(24, 4)
        if (res.trim().length > 28) {
          this.otherPayeeSEPA.reEnteredToAccount = res.trim().substring(0, 34)
        } else {
          this.otherPayeeSEPA.reEnteredToAccount = res.trim()
        }
      }
    },
    querySelections (v) {
      this.loading = true
      // Simulated ajax query
      setTimeout(() => {
        this.items = this.sortCodesList.filter((e) => {
          return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1
        })
        this.loading = false
      }, 500)
    },
    onClosePayeeDrawer () {
      if (this.enableSortCodeSearchForm) {
        // clears all search sortcode fields
        this.$refs.searchSortCodeForm.reset()
        this.sortCodeResults = []
      }
      this.enableSortCodeSearchForm = false
    },
    showDivider (index, array) {
      return array.length ? index + 1 < array.length : false
    },
    maskSortCode (code) {
      let maskedCode = ''
      if (code) {
        const sortCode = code.toString()
        for (let i = 0; i < sortCode.length; i++) {
          if (i % 2 === 0) {
            maskedCode = maskedCode + sortCode.substr(i, 2)
          } else if (i !== sortCode.length - 1) {
            maskedCode = maskedCode + '-'
          }
        }
      }
      return code ? maskedCode : ''
    },
    onAddPayee (type) {
      switch (type) {
        case 'UKFPS':
          if (this.enableEBAVCheckForAddPayee) {
            this.accountEbavCheck('UKFPS')
          } else this.validatePayeeAccount()
          break
        case 'SEPA':
          if (this.enableEBAVCheckForAddPayee) {
            this.accountEbavCheck('SEPA')
          } else this.sepaCreatePayeeInit()
          break
        case 'SWIFT':
          // this.createBeneficiaryAccount()
          this.swiftCreatePayee()
          break
        default:
          if (this.enableOTPToSameBank) {
            this.showOTPScreen = true
            this.beneficiaryOtpConfig.enabled = true
            setTimeout(() => {
              event.$emit('SEND_OTP', true)
            }, 1000)
          } else {
            this.createBeneficiaryAccount('IntraBank')
          }
          break
      }
    },
    isSearchDataValid () {
      if (
        this.searchSortCodeForm.bankName &&
        this.searchSortCodeForm.branchName &&
        this.isSortCodeSearchFormValid
      ) {
        return false
      } else if (
        this.searchSortCodeForm.sortCode &&
        this.isSortCodeSearchFormValid
      ) {
        return false
      } else return true
    },
    removeMasking (code) {
      return code ? code.replace(/-/g, '') : ''
    },
    convertToCapitalisedSentence (sentence) {
      return this.$formatter.convertCase.convertToCapitalisedSentence(sentence)
    },
    onOtpModalClose () {
      this.beneficiaryOtpConfig.enabled = false
      this.showOTPScreen = false
    },
    isNumberMatched (firstVal, secondVal) {
      return firstVal && secondVal ? firstVal !== secondVal : false
    },
    isValidFormat (element, index, array) {
      const res = this.numberCheck(element)
      return res !== 'Invalid Format'
    },
    onSortCodeSelect (data) {
      this.otherSortCode = this.maskSortCode(data.nationalid)
      this.otherPayeeBankName = this.convertToCapitalisedSentence(
        data.instname
      )
      if (this.enableSortCodeSearchForm) {
        this.$refs.searchSortCodeForm.reset()
      }
      this.enableSortCodeSearchForm = false
      this.sortCodeResults = []
    },
    sepaCreatePayeeInit () {
      if (this.enableOTPToSEPA) {
        this.beneficiaryOtpConfig.enabled = true
        this.showOTPScreen = true
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 1000)
      } else {
        this.createBeneficiaryAccount('SEPA')
      }
    },
    async swiftCreatePayee () {
      if (this.enableOTPToSWIFT) {
        this.beneficiaryOtpConfig.enabled = true
        this.showOTPScreen = true
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 1000)
      } else {
        this.createBeneficiaryAccount('SWIFT')
      }
    },
    async getActiveCurrencyFromService () {
      const response = await commonService.getActiveCurrencyFromService()
      this.currencyTypes = response.items
      return this.currencyTypes
    },
    async accountEbavCheck (type) {
      try {
        let validatePayload = {}
        if (type === 'UKFPS') {
          validatePayload = {
            accountNumber: this.otherAccNumber,
            sortCode: this.removeMasking(this.otherSortCode),
            partyId: this.isSmeLogin ? this.corporateId : this.userId
          }
        } else {
          validatePayload = {
            accountNumber: this.otherPayeeSEPA.reEnteredToAccount.replace(/\s+/g, ''),
            sortCode: this.removeMasking(this.otherPayeeSEPA.sortCode),
            partyId: this.isSmeLogin ? this.corporateId : this.userId
          }
        }
        const response = await commonService.accountEbavCheck(validatePayload)
        if (response && !response.causes && response.externalBankAccountVerification) {
          if (type === 'UKFPS') {
            this.validatePayeeAccount()
          } else {
            this.sepaCreatePayeeInit()
          }
        } else {
          this.$store.dispatch('appStore/setAppData', {
            message: {
              title: 'Error',
              width: 400,
              persistent: true,
              saveButton: this.$t('common.okay'),
              content: this.$t('domesticPayments.validatePayeeError'),
              type: 'error',
              component: 'dob-modal'
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async validatePayeeAccount () {
      // this.$refs.otherPayeeUKFPSForm.validate()
      try {
        const validatePayload = {
          accountNumber: this.otherAccNumber,
          type: 'UKFPS',
          hostId: 'MPM',
          sortCode: this.removeMasking(this.otherSortCode)
        }
        const response = await commonService.validateAccount(validatePayload)
        if (response && !response.causes && response.valid) {
          if (this.enableOTPToUKFPS) {
            this.beneficiaryOtpConfig.enabled = true
            this.showOTPScreen = true
            setTimeout(() => {
              event.$emit('SEND_OTP', true)
            }, 1000)
          } else {
            this.createBeneficiaryAccount('UKFPS')
          }
        } else {
          this.$store.dispatch('appStore/setAppData', {
            message: {
              title: 'Error',
              width: 400,
              persistent: true,
              saveButton: this.$t('common.okay'),
              content: this.$t('domesticPayments.validatePayeeError'),
              type: 'error',
              component: 'dob-modal'
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async onSearchSortCode () {
      const searchPayload = {
        networkName: 'UKFPS',
        branch: this.searchSortCodeForm.branchName,
        bankName: this.searchSortCodeForm.bankName,
        directoryIdentifier: this.removeMasking(
          this.searchSortCodeForm.sortCode
        ),
        reachability: 'A',
        wildCardSearch: true
      }
      const searchResponse = await commonService.searchUkfpsSortCode(
        searchPayload
      )
      if (searchResponse && !searchResponse.causes) {
        this.sortCodeResults = searchResponse
      }
      if (!searchResponse.length) {
        this.searchSortCodeForm.isSearchAvailable = false
      }
    },
    async getBICFromIBAN () {
      try {
        if (this.otherPayeeSEPA.reEnteredToAccount && this.otherPayeeSEPA.reEnteredToAccount.length
        ) {
          const response = await commonService.getBICFromIBAN(
            this.otherPayeeSEPA.reEnteredToAccount.replace(/\s+/g, '')
          )
          if (response && response.valid && !response.causes) {
            this.otherPayeeSEPA.sortCode = response.ibanBic
          } else {
            this.$store.dispatch('appStore/setAppData', {
              message: {
                title: 'Error',
                width: 400,
                persistent: true,
                btn2Label: this.$t('common.okay'),
                content: this.$t('internationalPayments.deriveBICError'),
                type: 'error',
                component: 'dob-modal'
              }
            })
          }
        } else {
          const toAccount = this.swiftPayee.selectedToAccount.replace(/\s+/g, '')
          if (toAccount.length) {
            const response = await commonService.getBICFromIBAN(toAccount)
            if (response && response.valid && !response.causes) {
              if (this.swiftPayee.selectedToAccount) {
                this.swiftPayee.selectedBicCode = response.ibanBic
                await this.setPayeeBankDetails(this.swiftPayee.selectedBicCode)
              }
            } else {
              this.isInvalidIBAN = true
              this.$store.dispatch('appStore/setAppData', {
                message: {
                  title: 'Error',
                  width: 400,
                  persistent: true,
                  saveButton: this.$t('common.okay'),
                  content: this.$t('internationalPayments.deriveBICError'),
                  type: 'error',
                  component: 'dob-modal'
                }
              })
            }
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    buildFormData (payload) {
      const {
        businessType,
        docCategory,
        docType
      } = this.$appSettings.defaultConfigurations.payeeSupplementaryDocuments[
        payload.paymentSystem === 'SWIFT' ? 'SWIFT' : 'SEPA'
      ]
      const form = new FormData()
      form.append('businessType', businessType)
      form.append('businessValue', payload.beneficiaryId)
      form.append('docCategory', docCategory)
      form.append('docType', docType)
      form.append('userId', payload.customerId)

      const filenames = []
      this.supplementaryDocuments.forEach(file => {
        form.append('document', file)
        filenames.push(file.name)
      })
      form.append('docReferences', JSON.stringify(filenames))
      form.append('payload', JSON.stringify(payload))
      return form
    },
    async createBeneficiaryAccount () {
      const customerId = JSON.parse(sessionStorage.getItem('username'))

      this.loaderEnabled = true
      let data = {}
      const storeData = this.$store.getters['profileStore/profileData']
      const customerFullName = storeData.customerDetails
        ? storeData.fullName
        : ''
      if (this.selectedAccountType === payeeBankType.SAMEBANK) {
        data = {
          customerId,
          beneficiaryAccount: this.sameAccNumber,
          beneficiaryReference: this.samePayeeName
        }

        if (this.enableIBANAccountNumberDisplay) {
          data.beneficiaryAccountType = 'IBAN'
        }
      } else {
        if (this.isDefaultPayee === 'UKFPS') {
          data = {
            customerId,
            name: this.otherPayeeName || customerFullName,
            accountIdentificationType: 'PROPRIETARY',
            accountIdentification: this.otherAccNumber,
            country: this.UKFPSpayemntTemplate.country,
            currency: this.UKFPSpayemntTemplate.currency,
            paymentSystem: 'UKFPS',
            bankIdentifier: this.removeMasking(this.otherSortCode),
            ownAccount: this.isOwnAccLinked === 'own'
          }
        } else if (this.isDefaultPayee === 'SWIFT') {
          data = {
            customerId,
            name: this.swiftPayee.selectedPayeeName,
            beneficiaryAccountType: this.swiftPayee.selectedIBANValue ? 'IBAN' : 'PROPRIETARY',
            beneficiaryAccountNumber: this.swiftPayee.selectedToAccount,
            beneficiaryBankBic: this.swiftPayee.selectedBicCode,
            currency: this.swiftPayee.selectedCurrencyCode,
            paymentSystem: 'SWIFT',
            bankIdentifier: this.swiftPayee.selectedBicCode,
            ctry: this.swiftPayee.selectedCountryCode,
            pstCd: this.swiftPayee.postCode,
            twnNm: this.swiftPayee.town
          }
        } else {
          data = {
            customerId,
            name: this.otherPayeeSEPA.accountName || customerFullName,
            accountIdentificationType: 'IBAN',
            accountIdentification: this.otherPayeeSEPA.reEnteredToAccount.replace(/\s+/g, ''),
            country: this.SEPApayemntTemplate.country,
            currency: this.SEPApayemntTemplate.currency,
            paymentSystem: 'STEP2',
            bankIdentifier: this.otherPayeeSEPA.sortCode,
            ownAccount: this.isOwnAccLinked === 'own'
          }
          // Add mapping of Address Fields for SEPA Payee when config for Address fields input is enabled
          if (this.isAddPayeeAddressEnabled) {
            const payeeAddressData = Object.fromEntries(
              Object.entries(this.payeeAddressFormData).filter(([_, value]) => value != null && value !== '')
            )

            data = {
              ...data,
              ...payeeAddressData
            }
          }
        }
        if (this.enableUDFBeneficiaryForAddPayee) {
          // const additionalProperties = this.schema?.beneficiaryDetails?.model
          data = {
            ...data,
            'custom-fields': {
              additionalProperties: this.udfFormData
            }
          }
        }
      }
      data.beneficiaryId = uuidv4().replace(/-/g, '').substring(0, 30)
      let form
      const hasDocuments = this.supplementaryDocuments?.length >= 1
      if (hasDocuments) {
        form = this.buildFormData(data)
      }
      const resp =
        this.isDefaultPayee === 'SWIFT'
          ? this.supplementaryDocuments?.length
            ? await commonService.uploadAndCreatePayee('swift', form)
            : await commonService.createSwiftBeneficiaries(data)
          : this.selectedAccountType === payeeBankType.SAMEBANK
            ? await commonService.createIntraPayeeAccount(data)
            : (this.isSupplementaryDocumentEnabled && hasDocuments)
              ? await commonService.uploadAndCreatePayee('sepa', form)
              : await commonService.createBeneficiaryAccount(data)
      this.loaderEnabled = false
      if (resp && !resp.causes) {
        this.onOtpModalClose()
        this.beneficiaryConfirmModal = true
        this.isAddNewPayeeAccComplete = true
        this.confirmData = {
          selectedAccountType: this.selectedAccountType,
          resp: resp,
          isNominatedAccount: this.appSettings.enableNominatedAccountFeatures && this.appSettings.enablePaymentsOnlyToNominatedAccounts
        }
      } else {
        if (resp?.internalType === 'OTP-ERROR') {
          event.$emit('otp_validation_failed', resp)
          return
        }
        event.$emit('reset_OTPField', true)
        this.onOtpModalClose()
        this.loaderEnabled = false
      }
    },
    async getGenericCodes () {
      const code = {
        codeReferences: [{ reference: 'ISOCountryCode2Char' }]
      }
      const response = await commonService.getGenericCodes(code)
      if (response && response.aggregateCodes && response.aggregateCodes[0]) {
        if (response.aggregateCodes[0].codes) {
          this.listCountryCodes = response.aggregateCodes[0].codes
        }
      }
    },
    clearBICError () {
      /** Capitalize text on to account input field */
      if (this.swiftPayee.selectedIBANValue && this.swiftPayee.selectedToAccount) {
        this.swiftPayee.selectedToAccount = this.swiftPayee.selectedToAccount.toUpperCase()
      }

      if (this.isInvalidIBAN) {
        this.isInvalidIBAN = false
      }
      /** Clear and reset the BIC Code field if the field already has a value and user tries to edit the To IBAN */
      if (this.swiftPayee.selectedBicCode) {
        this.swiftPayee.selectedBicCode = ''
        this.$refs.swiftBicCode.reset()
      }
      if (this.isInvalidBic) this.isInvalidBic = false
    },
    clearBICFieldError () {
      if (this.isInvalidBic) {
        this.isInvalidBic = false
        this.$refs.swiftBicCode.resetValidation()
      }
    },
    async setPayeeBankDetails (bicCode) {
      const payload = {
        networkName: 'SWIFT',
        bankIdentifier: bicCode
      }
      const payeeBankDetails = await commonService.searchUkfpsSortCode(payload)
      this.payeeBank = payeeBankDetails?.find(detail => detail.address)
      this.isInvalidBic = !this.payeeBank
    },
    nextStep () {
      if (this.step < this.steps.length) {
        this.step++
      }
    },
    prevStep () {
      if (this.step > 1) {
        this.step--
      }
    },
    resetForm () {
      this.udfFormData = null
      this.disableAddPayeeBtn = true
      if (this.selectedAccountType === payeeBankType.OTHERBANK) {
        this.samePayeeName = ''
        this.sameAccNumber = ''
        this.sameConfirmAccNumber = ''
      } else {
        this.otherPayeeName = ''
        this.otherAccNumber = ''
        this.otherConfirmAccNumber = ''
        this.otherSortCode = ''
        this.otherPayeeBankName = ''
        this.otherPayeeSEPA.accountName = ''
        this.otherPayeeSEPA.reEnteredToAccount = ''
        this.otherPayeeSEPA.sortCode = ''
        this.isOwnAccLinked = this.appSettings.enablePaymentsOnlyToNominatedAccounts ? 'own' : null
      }
    },
    resetOtherPayeeForm () {
      this.supplementaryDocuments = []
      this.udfFormData = null
      this.isOwnAccLinked = this.appSettings.enablePaymentsOnlyToNominatedAccounts ? 'own' : null
      if (this.isDefaultPayee === 'UKFPS') {
        this.otherPayeeName = ''
        this.otherAccNumber = ''
        this.otherConfirmAccNumber = ''
        this.otherSortCode = ''
        this.otherPayeeBankName = ''
      } else {
        this.otherPayeeSEPA.accountName = ''
        this.otherPayeeSEPA.reEnteredToAccount = ''
        this.otherPayeeSEPA.sortCode = ''
      }
      this.step = this.enableUDFBeneficiaryForAddPayee ? 1 : this.step
    },
    isPristine () {
      this.addNewPayeeDataSanity = true
    },
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
    },
    checkAccountInput (input) {
      return this.enableIBANAccountNumberDisplay ? this.ibanCheck(input) : this.numberCheck(input)
    },
    gotoManagePayee () {
      this.$router.push('payee')
    }
  }
}
</script>

<style lang="scss" scoped>
.align-bottom {
  margin-top: 50px;
}

#sortCodeField {
  padding: 0px 0px !important;
}

.v-stepper {
  border: none !important;
  box-shadow: none !important;
}

.v-stepper__header {
  border-bottom: none !important;
  box-shadow: none !important;
}

.custom-form {
  border: none !important;
  box-shadow: none !important;
}
</style>
